import React from 'react';
import ReactDOM from 'react-dom';
import Corepage from './../../views/core/CorePage';
/*import slowconnection from './../../images/network/slowconnection.gif';
import internetbroken from './../../images/network/internetbroken.gif';*/
import HmEventRegistry from './../../model/HmEventRegistry';
import AssetModel from './../../model/AssetModel';
import { confirmAlert } from 'react-confirm-alert'; 
import 'react-confirm-alert/src/react-confirm-alert.css';
import ReactHtmlParser from 'react-html-parser';

class NetworkCheck extends Corepage {

	constructor(props){
		super(props);

		this.instantKill = this.instantKill.bind(this);		
	}

	netcheckFn(){
		let assetModel = new AssetModel();

		if(this.props.type=="slow"){
			//return slowconnection;
			return assetModel.getSlowImg();
		}else if(this.props.type=="broken"){
			//return internetbroken;
			return assetModel.getNoInternetImg();
		}
	}

	instantKill(){
		if(document.getElementById('subroot').innerHTML && document.getElementById('subroot').innerHTML.length > 0){
			ReactDOM.unmountComponentAtNode(document.getElementById('subroot'));
		}		
	}

	showNetworkAlert(){
		let me=this;
		var title = this.rb("title.net."+this.props.type);
		var msg = this.rb("label.net."+this.props.type);
		var msg1 = this.rb("label.net.msg1");
		
		const styles={
			float:"right",
			cursor:"pointer"
		}
		confirmAlert({
			willUnmount:me.instantKill,
			customUI: ({ onClose }) => {
				return (
					<div id="networkcheck" className='custom-ui-alert'>

					<div>
					<span style={styles} className="" onClick={onClose}> <i className="material-icons">close</i></span>	
					</div>

					<div className="row">

					<div className="col-sm-12 col-xm-5 col-md-5 col-lg-5 img_sec nopadding">
					<img src={me.netcheckFn()} />
					</div>

					<div className="col-sm-12 col-xs-6 col-md-6 col-lg-6 networkinfo">

					<div>
					<h1>{title}</h1>
					</div>

					{ReactHtmlParser(msg)}<br/>{ReactHtmlParser(msg1)} 
					</div>

					</div>

					</div>
					)
				},
				closeOnClickOutside : false
			})

		}  
		showSlowNetwork(){
			let me=this;
			var title = this.rb("title.net."+this.props.type);
			var msg = this.rb("label.net."+this.props.type);
			var msg1 = this.rb("label.net.msg1");

			const styles={
				float:"right",
				cursor:"pointer"
			}
			confirmAlert({
				willUnmount:me.instantKill,
				customUI: ({ onClose }) => {
					return (
					<div id="networkcheck" className='custom-ui-alert'>

					<div>
					<span style={styles} className="" onClick={onClose}> <i className="material-icons">close</i></span>	
					</div>

					<div className="row">

					<div className="col-12 slow_img nopadding">
					<img src={me.netcheckFn()} />
					</div>

					<div className="col-12 slow_sec networkinfo">

					<div>
					<h1>{title}</h1>
					</div>

					{ReactHtmlParser(msg)}
					</div>

					</div>

					</div>
					)
				},
				closeOnClickOutside : false
			})

		}  
		switchNetworkAlert() {
			if(this.props.type=="slow"){
				//return slowconnection
				{this.showSlowNetwork()}			
			}else if(this.props.type=="broken"){
			//return internetbroken;
			{this.showNetworkAlert()}
		}
	}

	render() {
		let me = this;
		return(
			<div>
			<div className="container text-center">

			{this.switchNetworkAlert()}

			</div>
			</div>
			);
	}
}

export default NetworkCheck;


HmEventRegistry.registerEvent("SLOW_NET_2", function(){
	ReactDOM.render(<NetworkCheck type={"slow"}/>, document.getElementById('subroot'));	
});

HmEventRegistry.registerEvent("NO_NET_2", function(){
	ReactDOM.render(<NetworkCheck type={"broken"}/>, document.getElementById('subroot'));	
});


// WEBPACK FOOTER //
// ./src/components/common/NetworkCheck.js